import React from 'react';

const SystemHealth = () => {
    // Mock health for now - in future could hook into actual healthcheck endpoints
    const health = {
        database: 'Connected',
        ai_services: 'Online',
        storage: 'Optimal',
        latency: '42ms'
    };

    return (
        <div className="bg-gray-800 rounded-lg border border-gray-700 shadow-lg overflow-hidden flex flex-col h-full">
            <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex-shrink-0">
                <h2 className="text-gray-400 font-bold uppercase tracking-wider flex items-center gap-2 text-sm sm:text-base">
                    <span role="img" aria-label="gear">⚙️</span>
                    System Health
                </h2>
            </div>
            <div className="p-4 space-y-3 text-xs">
                <div className="flex justify-between items-center">
                    <span className="text-gray-400">Database</span>
                    <span className="text-green-400 font-bold flex items-center gap-1">
                        <span className="w-2 h-2 rounded-full bg-green-500"></span> {health.database}
                    </span>
                </div>
                <div className="flex justify-between items-center">
                    <span className="text-gray-400">AI Services</span>
                    <span className="text-green-400 font-bold flex items-center gap-1">
                        <span className="w-2 h-2 rounded-full bg-green-500"></span> {health.ai_services}
                    </span>
                </div>
                <div className="flex justify-between items-center">
                    <span className="text-gray-400">Storage</span>
                    <span className="text-green-400 font-bold flex items-center gap-1">
                        <span className="w-2 h-2 rounded-full bg-green-500"></span> {health.storage}
                    </span>
                </div>
                <div className="flex justify-between items-center pt-2 border-t border-gray-700">
                    <span className="text-gray-500">Avg Latency</span>
                    <span className="text-gray-300 font-mono">{health.latency}</span>
                </div>
            </div>
        </div>
    );
};

export default SystemHealth;
